import React from 'react';
import { useLivePageContent } from '@/hooks/usePageContent';
import { PublicLayout } from '@/components/public/PublicLayout';
import { Seo } from '@/components/Seo';
import { SilaWorld3D } from '@/components/public/SilaWorld3D';
import { ParkInfoSection } from '@/components/public/ParkInfoSection';
import { ParkGuidesShowcase } from '@/components/public/ParkGuidesShowcase';
import { ParkReviews } from '@/components/public/ParkReviews';

const str = (v) => (typeof v === 'string' || typeof v === 'number' ? String(v) : '');

/**
 * "Il Parco della Sila" — pagina dedicata alla grande mappa 3D immersiva dei Parchi
 * (SilaWorld3D, invariata) con le recensioni pubbliche in fondo.
 * NON modifica SilaWorld3D (regola mappa). Titolo/descrizione (SEO) editabili dal CRM.
 */
export default function IlParcoDellaSila() {
  const ov = useLivePageContent('il-parco-della-sila');

  const title = str(ov.title) || 'Il Parco della Sila';
  const desc = str(ov.lead) || 'Vola sul Parco Nazionale della Sila in 3D: sentieri, punti panoramici e itinerari delle guide. Prenota escursioni e tour.';

  return (
    <PublicLayout>
      <Seo title={title} description={desc} path="/il-parco-della-sila" />
      <SilaWorld3D />
      <ParkInfoSection content={ov} />
      <ParkGuidesShowcase />
      <ParkReviews />
    </PublicLayout>
  );
}
